import React from "react";

export const CTASection: React.FC = () => {
  const whatsappLink = "https://wa.me/27679376048";

  return (
    <section className="py-xl bg-surface-bright border-y border-outline-variant">
      <div className="max-w-container-max mx-auto px-md text-center">
        <div className="bg-secondary-container p-lg rounded-[2rem] border border-secondary/20">
          <h2 className="font-headline-lg text-headline-lg text-primary mb-md">
            Ready for a cleaner space?
          </h2>
          <p className="font-body-md text-on-secondary-container mb-lg max-w-xl mx-auto">
            Get a personalized quote today and discover why professional
            cleanliness is essential for your peace of mind.
          </p>
          <a
            className="inline-flex items-center justify-center bg-brand-gradient text-on-primary px-xl py-md font-bold rounded-full shadow-lg hover:shadow-primary/20 transition-all hover:-translate-y-1"
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
          >
            Request a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
};
